import { MAX_4U_WIDTH, MAX_NARROW_WIDTH_PRINT } from './constants';
/**
 * Processes and build the chart series data.
 */

export default function processSeries(options) {
  // Prepare series for Highcharts.
  options.originalSeries = options.series.map(currentSeries => currentSeries.data.map(data => Object.assign({}, data)));
  const { liveMarketData } = options;
  let data = options.series.map(item => {
    const { name, symbol, decimals, prefix, suffix, markdown, showInLegend, tickerType } = item;
    let series = {
      zoneAxis: options.type === 'line' ? 'x' : 'y',
      zones: getZones(options, item.data, item.color),
      zIndex: getZIndex(liveMarketData, tickerType),
      data: item.data,
      name,
      symbol,
      decimals,
      prefix,
      suffix,
      step: options.step ? 'left' : null,
      markdown,
      showInLegend,
      animation: false,
      color: item.color || options.defaults.colors[0],
      fillColor: options.type === 'area' && item.color === 'rgba(0, 0, 0, 0)' ? 'rgba(0,0,0,0)' : null,
      dashStyle: options.step || item.dashStyle !== 'dotted' ? 'solid' : 'dot',
      negativeColor: options.colorMode === 'THRESHOLD' && (options.type === 'column' || options.type === 'bar') ?
        item.negativeColor || options.defaults.colors[1]
        :
        null,
      events: {
        legendItemClick: function () { return false; }
      },
      turboThreshold: 0,
      states: {
        hover: {
          enabled: options.type === 'line'
        },
        inactive: {
          enabled: false
        }
      }
    };
    return series;
  });
  if (options.categoriesAreMonthly && options.type === 'column') {
    startOfMonth(data);
  }
  // Customize the data for the particular chart type.
  switch (options.type) {
    case 'pie':
      data = data.slice(0, 1);
      break;
    case 'bar':
      // Save data to do this later, when options.styles.lineHeight is known.
      // return truncateData(options, data);
      options.series = data;//sortData(data, options);
      return options;
    case 'column':
      const forceLegendTop = checkForceLegendTop(options);
      const rightLegend = options.legend.layout === 'right' ||
        options.legend.layout === 'default' && !forceLegendTop;
      const reverseLegend = needsReverseLegend(rightLegend, data);
      data = options.stacking ? reverseDataOrder(data, reverseLegend) : data;
      break;
    case 'line':
      data=handleLineData(data, options);
      break;
  }
  
  options.series = data;//sortData(data, options);
  for (let i = 0; i < options.series.length; i++) {
    let seriesData = options.series[i].data;
    for (let z = 0; z < seriesData.length; z++) {
      seriesData[z].index = z;
    }
  }
  return options;
}

export function checkForceLegendTop(options) {
  return options.id === 'video' || options.id ==='twitterVideo' ||
    (options.legend.layout === 'default' &&
    (options.print && options.width <= MAX_NARROW_WIDTH_PRINT ||
    !options.print && options.width <= MAX_4U_WIDTH));
}

export function convertToRGBA(color, opacity = 100) {
  let rgb = '';
  for (let i = 1; i <= 5; i += 2) {
    rgb += parseInt(color.slice(i, i + 2), 16) + ',';
  }
  const percent = opacity / 100;
  return `rgba(${rgb}${percent})`;
}

function needsReverseLegend(rightLegend, data) {
  const lastSeriesFirstValue = data[data.length - 1].data[0].y;
  const isNegative = lastSeriesFirstValue < 0;
  return rightLegend && !isNegative;
}

function getZIndex(liveMarketData, tickerType) {
  if (liveMarketData) {
    return tickerType === 'Index' ? 1 : 2;
  }
}

function getZones(options, data, seriesColor) {
  if (options.type === 'line' && options.connectEmptyDataPoints === 'dotted') {
    const isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
    let hasData = data[0].y !== null;
    return data.map((point, index) => {
      if (hasData && point.y === null || !hasData && point.y !== null) {
        const [offset, dashStyle, color] = hasData ?
          [1, 'solid', seriesColor]
          :
          noDataOptions(isVideoGroup, seriesColor);
        const value = data[index - offset].x;
        hasData = !hasData;
        return { value, dashStyle, color };
      }
    }).filter(zone => zone);
  }
}

function noDataOptions(isVideoGroup, seriesColor) {
  const attrs = isVideoGroup ?
    ['solid', convertToRGBA(seriesColor, 50)]
    :
    ['dot', seriesColor];
  return [0, ...attrs];
}

// For line charts, first column should be top layer. This also reverses the
// legend items, so that must be fixed separately.
function reverseDataOrder(data, reverseLegend = false) {
  const dataLen = data.length;
  data.forEach((item, index) => {
    item.index = dataLen - index - 1;
    item.legendIndex = reverseLegend ? dataLen - index - 1 : index;
  });
  return data;
}

function handleLineData(data, options){
 reverseDataOrder(data);
 if(options.legend.itemsInOrder === undefined){
  //sets default for 'market' charts
  //keeps old econ charts as they were
  if(options.tickers.length) options.legend.itemsInOrder = true;
  //everything else
  else options.legend.itemsInOrder = false;
}
//if legend is right aligned, always order items by final value, if itemsInOrder toggled on, switch order for 'top' aligned items
if(options.legend.layout === 'default' && !checkForceLegendTop(options) || options.legend.layout === 'right'){
  setLengendItemsOrder(data);
  } else if(options.legend.itemsInOrder && (checkForceLegendTop(options) || options.legend.layout === 'top')) {
   setLengendItemsOrder(data);
 }
 return data;
}

function setLengendItemsOrder(series){
  //array sorted by lastValue of each series in descending order [{seriesIdx, lastValue}]
    const sortedArr = series.reduce((accum, s, idx) => {
      //noticed that sometimes last value comes as null
      for(let i = 1; i<s.data.length; i++){
        if(s.data[s.data.length-i].y !== null && s.data[s.data.length-i].y) {
          accum.push({seriesIdx: idx, lastValue:s.data[s.data.length-i].y});
          break;
        }
      }
        return accum;
      }, []).sort((a, b) => b.lastValue - a.lastValue);
    //updates order of legend items
    sortedArr.forEach((s, i) => {
      series[s.seriesIdx].legendIndex = i;
    })
}

function startOfMonth(data) {
  // for column charts with one date per month, shift x value to first of month
  data.forEach(series => {
    series.data.forEach(position => {
      const date = new Date(position.x);
      date.setUTCDate(1);
      position.x = date.valueOf();
    })
  })
}


// For horizontal bar charts, removes data to improve visual appearance.
export function truncateData(options, data) {
  // Guestimate the maximum data rows that will fit.
  const maxRows = Math.floor(options.height /
    (parseFloat(options.styles.lineHeight.large) * 1.5));
  // Remove data so rows does not exceed maxRows.
  const overflow = Math.ceil(data[0].data.length / maxRows);
  const originalCategories = options.categories ?
    options.categories.slice() : null;
  let categories = [];
  if (overflow > 1) {
    data.forEach((item, index) => {
      let items = [];
      let n = 0;
      while (n < item.data.length) {
        if (index === 0 && options.categories) {
          categories.push(originalCategories[n]);
          options.categories = categories;
        }
        items.push(item.data[n]);
        n += overflow;
      }
      item.data = items;
    });
  }
  options.series = data;
  return options;
}



// WEBPACK FOOTER //
// ./src/chart/data/processSeries.js